import { Injectable } from '@angular/core';
import { MiaHttpService, ApiResponse } from '@mobileia/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetatagService extends MiaHttpService {

  constructor(
    protected http: HttpClient,
    protected title: Title,
    protected meta: Meta,
  ) {
    super(http);
  }

  configSlug(slug: string) {
    this.fetchBySlug(slug).toPromise().then(data => {
      if (!data.success) {
        this.resetConfig();
        return;
      }

      this.title.setTitle(data.response.title);
      this.meta.addTag({ name: 'description', content: data.response.meta});

      if (data.response.tags == undefined) {
        return;
      }

      for (const item of data.response.tags) {
        this.meta.addTag({ name: item.key, content: item.value });
      }
    });
  }

  resetConfig() {
    this.title.setTitle('Sin titulo');
    this.meta.updateTag({ name: 'description', content: 'Sin descripción'});
  }

  fetchBySlug(slug: string): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'config/fetch-page', { slug: slug });
  }

}
